import TimestampedFileCertification from './TimestampedFileCertification'

export default [{
  path: '/timestampedFile/:poe_id/certification',
  name: 'TimestampedFileCertification',
  component: TimestampedFileCertification,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Timestamped File Certification'}
}]



// WEBPACK FOOTER //
// ./src/pages/timestampFiles/router.js